// import React from "react";

import { toast } from 'react-toastify'
import UntagPersonsAtHeaderLevelFromMovieCollectionService from '../../Services/Mutations/UntagPersonsAtHeaderLevelFromMovieCollectionService'
import { ToastStyle } from '../Data/MovieStaticData'

// import { untagPersonsAtHeaderLevelFromMovieList } from '../../Graphql/mutations'

export default async function UntagpersonHeaderCollection(
  headerLevel,
  headerLevelPersons,
  movieCollectionID,
) {
  const personsnotintag =
    headerLevel &&
    headerLevel.filter(person => !headerLevelPersons.some(person2 => person === person2))
  const untagPersonsIds = personsnotintag.map(e => e.personID)
  console.log(untagPersonsIds, 'untagpersonsids')
  if (untagPersonsIds.length >= 1) {
    const input = {
      movieCollectionID,
      personIDs: untagPersonsIds,
    }
    const responseuntag = await UntagPersonsAtHeaderLevelFromMovieCollectionService(input)
    if (responseuntag.statusCode === 'A053') {
      toast.success(responseuntag.statusMessage, ToastStyle)
    }
    // return <div>UntagpersonHeaderCollection</div>;
  }
}
